import React, { CSSProperties, FC } from 'react';
import { Typography, TypographyProps } from '@mui/material';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
  text: {
    fontWeight: 'bold',
    fontStyle: 'normal',
    lineHeight: '266%',
    fontSize: 12,
    textTransform: 'uppercase',
    color: theme.palette.primary.main,
    letterSpacing: '1px',
    marginTop: '50px',
  },
}));

interface Props {
  text: string | React.ReactElement;
  className?: CSSProperties;
}

export const SubtitleOfSection: FC<Props & TypographyProps> = ({
  text,
  className,
  ...props
}) => {
  const { classes, cx } = useStyles();

  return (
    <Typography
      variant="h3"
      className={cx(classes.text, className)}
      {...props}
    >
      {text}
    </Typography>
  );
};
